import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpaLotus = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "spa-lotus" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.248,14.878a8.1,8.1,0,0,1-3-6,7.917,7.917,0,0,1,2.485-5.546.735.735,0,0,1,1.029,0,7.913,7.913,0,0,1,2.486,5.546A8.1,8.1,0,0,1,11.248,14.878Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.168,7.828a8.557,8.557,0,0,1,4.86-1.478.749.749,0,0,1,.748.744,7.91,7.91,0,0,1-2.164,5.663,8.1,8.1,0,0,1-6.364,2.121"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.326,7.839a8.489,8.489,0,0,0-4.9-1.489.749.749,0,0,0-.749.744,7.912,7.912,0,0,0,2.165,5.663,8.181,8.181,0,0,0,6.407,2.121"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.1,11.877C2.133,12.716.748,14.25.748,15.628c0,2.9,5.037,5.25,11.25,5.25a21.67,21.67,0,0,0,6.75-1.012V16.378h4.383a2.521,2.521,0,0,0,.117-.75c0-1.716-1.849-3.275-4.577-4.233"
		})
	]
});
export default SvgSpaLotus;
